import { render, staticRenderFns } from "./CompanyStatusC1.vue?vue&type=template&id=1fc0d628"
import script from "./CompanyStatusC1.vue?vue&type=script&lang=js"
export * from "./CompanyStatusC1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports